import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, } from "react-router-dom"

import Breadcrumb, {BreadcrumbItem} from '../../components/Breadcrumb';
import { BlankLink } from '../../components/CustomLink';

import { LocalCasheContext } from '../../context/LocalCacheContext';

import SearchForm, { defaultValues, SearchFormValues, getSearchValues, setSearchValues, clearSearchValues, } from './common/SearchForm';
 
const Search = () => {
    const navigate = useNavigate();

    const localCasheContext = useContext(LocalCasheContext);

    // 検索条件
    let values = getSearchValues(); // ストレージから検索値を取得
    const url = localCasheContext.pop('url'); // 前画面のURL
    const referrer = document.referrer; // 遷移元リファラー
    if (values) {

        // 1. 検索結果画面からの遷移を確認
        if (url && url.indexOf('/YDS/search/YDSG020SEARCH') > 1) {
            // 内部遷移なのでストレージ値を使用
        }
        // 2. リファラーから検索系外部からの遷移を判定
        else if (referrer.indexOf('/YDS/search/') == -1) {
            // 外部遷移なのでストレージ値を使用しない
            values = undefined;
        }

        // 不要なストレージ情報を削除
        clearSearchValues();
    }
    const searchValues: SearchFormValues = (values)?values:defaultValues;
    
    // 検索ボタンイベントハンドラ
    const handleSearch = (formData:any) => {
        // フォームでは付与されないパラメータ
        formData.page = defaultValues.page;
        formData.searchSort = "new";
        // 検索値をセッションストレージに保存
        setSearchValues(formData);
        // 次画面へ引き渡す
        navigate('/search/YDSG020SEARCH', {state:{'formData': formData}});
    }

    // パンくずリストリンク
    const breadcrumbItems:BreadcrumbItem[] = [
        {'label': 'ホーム', 'path': '/'},
        {'label': '語句検索', 'path':'/search/YDSG010'}
    ]

    //
    return (
        <>
        <Helmet>
            <title>語句検索 | 予算書・決算書データベース</title>
        </Helmet>
        <main id="main" className="l-contents-main">
        <div className="l-contents l-contents--head">
            <div className="l-contents__inner">

            <Breadcrumb itemLists = {breadcrumbItems} />

            <div className="c-blk-head">
                <h1 className="c-heading-lv1">語句検索</h1>
            </div>
            <div className="c-blk-txt c-blk-txt--lg">
                <p>複数の用語を入力する場合は、下記のとおり「AND検索」か「OR検索」をご利用可能です。</p>
            </div>
            <div className="c-blk-txt">
                <ul className="c-list-dots">
                <li>AND検索：用語と用語の間にスペースを空けてください。（例「復興　支援」）</li>
                <li>OR検索：用語と用語の間にスペースとOR（半角大文字）とスペースを入力してください。（例「復興　OR　支援」）</li>
                </ul>
            </div>
            <div className="c-blk-txt">
                <ul className="c-list-annotation">
                <li className="c-text-note">※AND検索とOR検索の指定が混在した検索はできません。</li>
                </ul>
            </div>
            </div>
        </div>
        <div className="l-contents l-contents--body">
            <div className="l-contents__inner">

            <SearchForm values={searchValues} accordionOpen={true} onSearch={handleSearch} />

            <div className="c-blk-head">
                <h2 className="c-heading-lv2">使い方</h2>
            </div>
            <div className="c-blk-txt">
                <p><BlankLink href="/manual/manual.pdf">検索操作マニュアル（PDF／100KB）</BlankLink></p>
            </div>
            </div>
        </div>
        </main>
        </>
    )
};

export default Search;